const cardRouter = [
  {
    path: '/card',
    name: 'CardIndex',
    component: () => import('@/views/card/index')
  },
  {
    path: '/card/:id(\\d+)/:key',
    name: 'CardDetailKey',
    component: () => import('@/views/card/detail')
  },
  {
    path: '/card/:id(\\d+)',
    name: 'CardDetail',
    component: () => import('@/views/card/detail')
  },
  {
    path: '/card/exchange',
    name: 'CardExchange',
    component: () => import('@/views/card/exchange')
  },
  {
    path: '/card/custom',
    name: 'CardCustom',
    component: () => import('@/views/card/custom')
  },
  {
    path: '/card/ticket',
    name: 'CardTicket',
    component: () => import('@/views/card/ticket')
  }
]

export default cardRouter



// WEBPACK FOOTER //
// ./src/router/modules/card.js